module.exports = __webpack_public_path__ + "static/media/budweiser_boomerang04.c6896b0d.webm";